<div class="table-contents mt-2" *ngIf="(errors | async ).length>0">

    <a class="btn btn-secondary errors" data-toggle="collapse" href="#collapseErrorsNoClikable" role="button" aria-expanded="false"
        aria-controls="collapseErrors">
        <span  *ngIf="(errors | async ).length == 1" [translate]="erreurMessages.erreurByStep"
            [translateParams]="{ value: errorLength }"></span>
        <span  *ngIf="(errors | async ).length > 1" [translate]="erreurMessages.erreursByStep"
            [translateParams]="{ value: errorLength }"></span>
    </a>

    <div class="alert alert-danger collapse" id="collapseErrorsNoClikable" role="alert">
        <div *ngFor="let fieldError of errors | async">
            <span>{{fieldError.errorMessage | translate}}</span>
        </div>
    </div>
</div>
